import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { GridEffects } from './grid.epic';
import { gridReducer } from './grid.reducer';
import { gridStateKey } from './grid.state';

export function provideGridCore() {
    return [provideState(gridStateKey, gridReducer), provideEffects(GridEffects)];
}
